export default "__VITE_ASSET__BAr7x6FE__"